
import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    
    setIsSubmitting(true);
    
    try {
      const formData = new FormData();
      formData.append('email', email);
      
      const response = await fetch('https://readdy.ai/api/form/newsletter-subscription', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
      }
    } catch (error) {
      console.error('Newsletter submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <section 
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url('https://public.readdy.ai/ai/img_res/cc5f33fe7d70400b7bb9dbfabb91c1c6.jpg')`
        }}
      >
        <div className="container mx-auto px-6 lg:px-8 text-center">
          <div className="max-w-2xl mx-auto">
            <div className="w-16 h-16 flex items-center justify-center bg-green-500 rounded-full mx-auto mb-6">
              <i className="ri-check-line text-2xl text-white"></i>
            </div>
            <h2 className="text-4xl font-bold text-white mb-4">Thank You!</h2>
            <p className="text-xl text-gray-200">
              You've successfully subscribed to our newsletter. Get ready for exclusive content and early episode access!
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section 
      className="py-20 bg-cover bg-center relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url('https://readdy.ai/api/search-image?query=Newsletter%20subscription%20concept%20with%20modern%20email%20marketing%20design%2C%20sleek%20metallic%20chrome%20surfaces%20with%20golden%20lighting%20effects%2C%20crimson%20red%20accent%20elements%2C%20professional%20business%20atmosphere%20with%20sophisticated%20aesthetic%20and%20depth&width=1920&height=600&seq=newsletter-bg&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
            Never Miss an{' '}
            <span className="text-red-600">Episode</span>
          </h2>
          
          <p className="text-xl md:text-2xl lg:text-3xl text-gray-200 mb-10 max-w-2xl mx-auto">
            Join our exclusive community and get early access to episodes, behind-the-scenes content, and special guest announcements delivered straight to your inbox.
          </p>
          
          <form id="newsletter-form" data-readdy-form onSubmit={handleSubmit} className="max-w-lg mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                className="flex-1 px-6 py-4 rounded-full text-lg text-black placeholder-gray-5   00 border-none focus:outline-none focus:ring-4 focus:ring-red-600/30"
                required
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-red-600 hover:bg-red-700 disabled:bg-red-400 text-white px-8 py-4 rounded-full text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe Now'}
              </button>
            </div>
            
            <p className="text-gray-300 text-base md:text-lg mt-4">
              No spam, unsubscribe at any time. We respect your privacy.
            </p>
          </form>
          
          <div className="flex items-center justify-center gap-12 mb-12 md:mb-16">
            <div className="text-center">
              <div className="text-lg md:text-xl lg:text-2xl font-bold text-gray-300 mb-2" style={{ fontFamily: '"Teko", sans-serif' }}>
                The
              </div>
              <div className="text-4xl md:text-5xl lg:text-7xl font-bold text-red-600" style={{ fontFamily: '"Teko", sans-serif' }}>
                GRIND
              </div>
            </div>
            
            <div className="flex items-end pb-6">
              <span className="text-red-600 text-4xl font-bold">•</span>
            </div>
            
            <div className="text-center">
              <div className="text-lg md:text-xl lg:text-2xl font-bold text-gray-300 mb-2" style={{ fontFamily: '"Teko", sans-serif' }}>
                The
              </div>
              <div className="text-4xl md:text-5xl lg:text-7xl font-bold text-red-600" style={{ fontFamily: '"Teko", sans-serif' }}>
                DRIVE
              </div>
            </div>
            
            <div className="flex items-end pb-6">
              <span className="text-red-600 text-4xl font-bold">•</span>
            </div>
            
            <div className="text-center">
              <div className="text-lg md:text-xl lg:text-2xl font-bold text-gray-300 mb-2" style={{ fontFamily: '"Teko", sans-serif' }}>
                The
              </div>
              <div className="text-4xl md:text-5xl lg:text-7xl font-bold text-red-600" style={{ fontFamily: '"Teko", sans-serif' }}>
                HUSTLE
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
}
